<template>
  <ul
    class="c-swatch-list"
    :class="{
      'l-flex': true,
      'u-margin-bottom-medium': ['always', 'active'].includes(showLabelWhen)
    }"
    role="menubar"
  >
    <li
      v-for="(color, index) in productColors"
      :key="swatchKey(color, index)"
      :aria-labelledby="swatchKey(color, index)"
      class="c-swatch-list__item"
      :class="[ 'u-margin-bottom-small' ]"
      role="menuitem"
    >
      <swatch
        :id="swatchKey(color, index)"
        class="c-swatch-list__swatch"
        :color="color"
        :render-link="renderLink"
        :active="activeSwatch(color)"
        :show-label-when="showLabelWhen"
        :show-image="true"
        @click="$emit('input', color)"
      />
    </li>
  </ul>
</template>

<script>
import ProductColors from '../../mixins/productColors'
import Swatch from './Swatch'

export default {
  components: {
    Swatch
  },
  mixins: [
    ProductColors
  ],
  props: {
    product: {
      type: Object,
      required: true
    },
    products: {
      type: Array,
      required: true
    },
    renderLink: {
      type: Boolean,
      default: false
    },
    activeSwatch: {
      type: Function,
      required: true
    },
    showLabelWhen: {
      type: String,
      default: 'active'
    }
  },
  methods: {
    swatchKey({ handle, name }, index) {
      return `c-swatch-list__${this._uid}-${index}-${handle}-${name}`
    }
  }
}
</script>

<style lang="scss" scoped>
.c-swatch-list {
  list-style: none;
  &__item { }
}
</style>
